import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './TableRow.less';

const TableRow = ({
  children,
  isSelected,
  isCondensed,
  hasHover,
  className,
  ...rest
}) => {
  const classes = classnames('Table__TableRow', className, {
    'Table__TableRow--condensed': isCondensed,
    'Table__TableRow--selected': isSelected,
    'Table__TableRow--hoverable': hasHover,
  });

  return (
    <tr {...rest} className={classes}>
      {children}
    </tr>
  );
};

TableRow.propTypes = {
  /**
   * Child nodes (e.g. TableHeaderCell, TableDataCell)
   */
  children: PropTypes.node.isRequired,

  /**
   * Highlights the row. Can be passed in manually on select
   */
  isSelected: PropTypes.bool,

  /**
   * Renders a more condensed variant
   */
  isCondensed: PropTypes.bool,

  /**
   * Determines if the row highlights on hover
   */
  hasHover: PropTypes.bool,

  /**
   * Additional classes to apply
   */
  className: PropTypes.string,
};

TableRow.defaultProps = {
  isSelected: false,
  isCondensed: false,
  hasHover: false,
  className: '',
};

export default TableRow;
